/**
 * Shared Tailwind preset — client-context tile tokens.
 *
 * Consumed by both:
 *   ui/tailwind.config.ts          (ora Remix app)
 *   the Outlook add-in's own tailwind.config.ts
 *
 * Contains the animations and keyframes used by ClientContextTile.
 * Colors (primary-success/warning/error/gray-light) are defined
 * independently in each app's own config — those are too broad to own here.
 *
 * NOTE — duplicate-class surface:
 *   The plugin's tailwind.config.ts previously defined clientCtxPulse and
 *   clientCtxFadeIn locally. Those local entries should be removed from the
 *   plugin config; this preset is now the single source of truth.
 *
 * NOTE — see-possible-tile-shadow:
 *   This utility is defined in @layer utilities in each app's CSS entry file:
 *     ora:    ui/app/tailwind.css (line 632)
 *     add-in: its own styles.css
 *   Both definitions must remain identical. Update both when changing shadows.
 */
import type { Config } from "tailwindcss";

const preset: Config = {
  content: [],
  theme: {
    extend: {
      keyframes: {
        clientCtxPulse: {
          "0%, 100%": { opacity: "1", transform: "scale(1)" },
          "50%": { opacity: "0.4", transform: "scale(0.75)" },
        },
        clientCtxFadeIn: {
          from: { opacity: "0" },
          to: { opacity: "1" },
        },
      },
      animation: {
        // ── Duplicate-class warning ──────────────────────────────────────────
        // These animation names are the shared tile's canonical identifiers.
        // Do NOT redefine them in any consuming app's tailwind.config.ts —
        // edit this file instead.
        // ─────────────────────────────────────────────────────────────────────
        "client-ctx-pulse": "clientCtxPulse 1.2s ease-in-out infinite",
        "client-ctx-fade-in": "clientCtxFadeIn 0.25s ease both",
      },
    },
  },
};

export default preset;
